

import { useRef, useState, useMemo, useEffect } from "react"
import { convertLocalDateTimeToUTC } from "../../../../components/dateTime"
import { Drawer, Box, IconButton, Checkbox, FormControlLabel, Typography, MenuItem, FormControl } from "@mui/material"
import profilecross from "../../../../assets/profilecross.svg"
import spanish from "../../../../assets/spanish.svg"
import usa from "../../../../assets/usa.png"
import germany from "../../../../assets/germany.png"
import france from "../../../../assets/france.webp"
import italy from "../../../../assets/italy.png"
import CustomText, { textStyles } from "../../../../components/CustomText"
import down from "../../../../assets/down.svg"
import arrow from "../../../../assets/arrow.svg"
import "../../../../App.css"
import drag from "../../../../assets/drag.svg"
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown"
import CustomButton from "../../../../components/CustomButton"
import save from "../../../../assets/save.svg"
import { useFormik } from "formik"
import { toast, Toaster } from "react-hot-toast"
import "react-phone-input-2/lib/style.css"
import PhoneInput from "react-phone-input-2"
import Select from "react-select"
import countryList from "react-select-country-list"
import { decryptToken } from "../../../../Utlis/Encryption"
import { BASE_URL } from "../../../../components/BaseUrl"
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LocationPermissionModal from "./permissionModal"
import ImageCropper from "../../../../components/ImageCropper"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Location from "./Locations";
import { showToast } from "../../../../Utlis/messageHandler";
import { Country, State, City } from "country-state-city";
import SearchableDropdown from "../../../../components/SearchComponent";
import Webcam from "react-webcam";
import Menu from "@mui/material/Menu";
import AddIcon from "@mui/icons-material/Add";
const AddCompanyDrawer = ({ open, onClose, onSuccess }) => {


  // ✅ Camera modal states (shared for all 3 uploads)
  const [showCamera, setShowCamera] = useState(false);
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [takingPhoto, setTakingPhoto] = useState(false);


  // ✅ which field is using camera right now: profile | admin | company
  const [cameraTarget, setCameraTarget] = useState(null);


  // ✅ Menus anchor states (3-dot / plus button menus)
  const [profileMenuEl, setProfileMenuEl] = useState(null);
  const [adminMenuEl, setAdminMenuEl] = useState(null);
  const [companyMenuEl, setCompanyMenuEl] = useState(null);


  const openProfileMenu = Boolean(profileMenuEl);
  const openAdminMenu = Boolean(adminMenuEl);
  const openCompanyMenu = Boolean(companyMenuEl);

  useEffect(() => {
    if (open) {
      formik.resetForm();
      setUploadedImage(null);
      setUploadedLogo(null);
      setImageFile(null);
      setLogoFile(null);
    } else {
      // Reset all fields when drawer is closed
      formik.resetForm();
      setUploadedImage(null);
      setUploadedLogo(null);
      setImageFile(null);
      setLogoFile(null);

      // Reset document upload states
      setUploadingAdminDoc(false);
      setAdminDocFileName("");
      setUploadingCompanyDoc(false);
      setCompanyDocFileName("");

      // Reset manual address states
      setShowManualAddress(false);
      setManualAddressCoords(null);
      setSelectedCountry("");
      setSelectedState("");
      setSelectedCity("");
      // Keep countries loaded for next time, only clear states and cities
      setManualStates([]);
      setManualCities([]);
      setLoadingCountries(false);
      setLoadingStates(false);
      setLoadingCities(false);

      // Reset location states
      setLocationAllowed(null);
      setForceLocationCheck(false);
      setMapValues(null);

      // Reset loading state
      setLoading(false);

      // Clear file input refs
      if (imageInputRef.current) imageInputRef.current.value = "";
      if (logoInputRef.current) logoInputRef.current.value = "";
      if (docInputRef.current) docInputRef.current.value = "";
      if (companyDocInputRef.current) companyDocInputRef.current.value = "";

      // Reset formik values to initial state
      formik.setValues({
        firstName: "",
        lastName: "",
        middleName: "",
        dob: "",
        adminType: "",
        adminDocumentUrl: "",
        email: "",
        phone: "",
        legalName: "",
        tradeName: "",
        businessEmail: "",
        businessPhone: "",
        businessAddress: "",
        businessSector: "",
        businessActivity: "",
        primaryColor: "#006EC2",
        secondaryColor: "#2C384C",
        companyRegistrationNo: "",
        companyDocumentUrl: "",
        // country: "Spain",
        // community: "",
        // province: "",
        // city: "",
        postalCode: "",
        streetAddress: "",
        // targetRegion: [],
        defaultLanguage: [],
        subscriptionType: [],
        latitude: "",
        longitude: "",
        timezone: "",
        countryCode: "",
        region: "",
        continent: "",
      });
    }
  }, [open]);
  const { t } = useTranslation();
  const imageInputRef = useRef()
  const logoInputRef = useRef()
  const [uploadedImage, setUploadedImage] = useState(null)
  const [uploadedLogo, setUploadedLogo] = useState(null)
  const rawEncryptedToken = localStorage.getItem("token")
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [logoFile, setLogoFile] = useState(null);

  // Image cropper states (only for company logo)
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppingType, setCroppingType] = useState(null); // 'logo' only
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [locationAllowed, setLocationAllowed] = useState(null);
  const [forceLocationCheck, setForceLocationCheck] = useState(false);
  const [showManualAddress, setShowManualAddress] = useState(false);

  // Document upload states
  const [uploadingAdminDoc, setUploadingAdminDoc] = useState(false);
  const [adminDocFileName, setAdminDocFileName] = useState("");
  const [uploadingCompanyDoc, setUploadingCompanyDoc] = useState(false);
  const [companyDocFileName, setCompanyDocFileName] = useState("");
  const [selectedCountryIso, setSelectedCountryIso] = useState("");
  const [selectedStateIso, setSelectedStateIso] = useState("");
  // File input refs
  const docInputRef = useRef();
  const companyDocInputRef = useRef();

  // Manual address dropdown states
  const [manualCountries, setManualCountries] = useState([]);
  const [manualStates, setManualStates] = useState([]);
  const [manualCities, setManualCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);




  const openCameraFor = (target) => {
    setCameraTarget(target); // "profile" | "admin" | "company"
    setCapturedImage(null);
    setShowCamera(true);
  };


  // ✅ Capture photo and route it to existing flow
  const capturePhoto = async () => {
    if (!webcamRef.current || !cameraTarget) return;


    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      toast.error("Failed to capture image");
      return;
    }


    setCapturedImage(imageSrc);
    setTakingPhoto(true);


    try {
      const blob = await fetch(imageSrc).then((res) => res.blob());


      // create a File so your existing code can reuse it easily
      const file = new File([blob], "camera.jpg", { type: "image/jpeg" });


      console.log("📸 Camera target:", cameraTarget);
      console.log("📸 Captured file:", { name: file.name, type: file.type, size: file.size });


      // 🔥 1) PROFILE PICTURE (keep your existing submit logic)
      if (cameraTarget === "profile") {
        // keep same UI behavior as gallery upload
        setUploadedImage(imageSrc); // just to show "uploaded"
        setImageFile(file); // submit will upload exactly like before
        toast.success(t("upload.imageUploaded"));
      }


      // 🔥 2) ADMIN DOCUMENT (upload immediately like current admin doc flow)
      if (cameraTarget === "admin") {
        setUploadingAdminDoc(true);
        setAdminDocFileName("camera.jpg");


        const url = await uploadImageToServer(file);
        console.log("🪪 Admin doc URL (camera):", url);


        formik.setFieldValue("adminDocumentUrl", url);
        toast.success(t("upload.documentUploaded"));
        setUploadingAdminDoc(false);
      }


      // 🔥 3) COMPANY DOCUMENT (upload immediately like current company doc flow)
      if (cameraTarget === "company") {
        setUploadingCompanyDoc(true);
        setCompanyDocFileName("camera.jpg");


        const url = await uploadImageToServer(file);
        console.log("🏢 Company doc URL (camera):", url);


        formik.setFieldValue("companyDocumentUrl", url);
        toast.success(t("upload.documentUploaded"));
        setUploadingCompanyDoc(false);
      }


      setShowCamera(false);
    } catch (err) {
      console.error(err);
      toast.error(t("addCompanyAdmin.toast.failedUploadDocument"));
    } finally {
      setTakingPhoto(false);
      setCameraTarget(null);
      // reset doc loading in case of fail
      setUploadingAdminDoc(false);
      setUploadingCompanyDoc(false);
    }
  };


  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    if (type === "image") {
      // Regular image upload for profile image
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedImage(e.target.result);
        setImageFile(file);
      };
      reader.readAsDataURL(file);
    } else if (type === "logo") {
      // ImageCropper for company logo
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      setCroppingType(type);
      setCropModalOpen(true);

      // Clear the input
      if (logoInputRef.current) {
        logoInputRef.current.value = "";
      }
    }
  };

  const handleCropComplete = async (croppedImageFile) => {
    if (!croppedImageFile) {
      toast.error(t("addCompanyAdmin.toast.selectCropArea"));
      return;
    }

    try {
      // Only handle logo cropping
      if (croppingType === "logo") {
        setUploadedLogo(URL.createObjectURL(croppedImageFile));
        setLogoFile(croppedImageFile);
        toast.success(t("upload.logoUploaded"));
      }

      setCropModalOpen(false);
      setSelectedImage(null);
      setCroppingType(null);
    } catch (err) {
      console.error('Upload error:', err);
      toast.error(t("addCompanyAdmin.toast.failedProcessLogo"));
    }
  };


  const [dropdownOpen, setDropdownOpen] = useState(false)
  const sectors = [
    t("addCompanyAdmin.type.fieldServices"),
    t("addCompanyAdmin.type.construction"),
    t("addCompanyAdmin.type.deliveryAndLogistics"),
    t("addCompanyAdmin.type.retail"),
    t("addCompanyAdmin.type.healthcareAndHomeCare"),
    t("addCompanyAdmin.type.securityServices"),
    t("addCompanyAdmin.type.itServicesAndSupport"),
    t("addCompanyAdmin.type.corporateOfficeWork"),
    t("addCompanyAdmin.type.hospitality"),
    t("addCompanyAdmin.type.educationAndTraining"),
    t("addCompanyAdmin.type.governmentAndPublicServices"),
    t("addCompanyAdmin.type.other"),
  ];

  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false)
  const countries = [
    { label: "Spain", icon: spanish },
    { label: "USA", icon: usa },
    { label: "Germany", icon: germany },
    { label: "France", icon: france },
    { label: "Italy", icon: italy },
  ]

  const [postalDropdownOpen, setPostalDropdownOpen] = useState(false)
  const postalCodes = ["28001", "28002", "28003"]
  const [mapValues, setMapValues] = useState(null);
  // State to track manual address coordinates for map update
  const [manualAddressCoords, setManualAddressCoords] = useState(null);

  useEffect(() => {
    console.log("[AddCompanyDrawer][Location] open:", open);
    console.log("[AddCompanyDrawer][Location] locationAllowed:", locationAllowed);
    console.log("[AddCompanyDrawer][Location] showManualAddress:", showManualAddress);
    console.log("[AddCompanyDrawer][Location] manualAddressCoords:", manualAddressCoords);
    console.log("[AddCompanyDrawer][Location] mapValues:", mapValues);
  }, [open, locationAllowed, showManualAddress, manualAddressCoords, mapValues]);

  const applyMapToForm = (data) => {
    console.log("[AddCompanyDrawer][Location] applyMapToForm payload:", data);
    formik.setFieldValue("country", data.country || "");
    formik.setFieldValue("community", data.community || "");
    formik.setFieldValue("province", data.province || "");
    formik.setFieldValue("city", data.city || "");
    formik.setFieldValue("postalCode", data.postalCode || "");
    formik.setFieldValue("streetAddress", data.streetAddress || data.address || "");
    formik.setFieldValue("latitude", data.latitude ?? "");
    formik.setFieldValue("longitude", data.longitude ?? "");

    console.log("📍 Map selected lat/long:", data.latitude, data.longitude);
  };

  const handleMapAddress = (data) => {
    console.log("[AddCompanyDrawer][Location] onChange from Location component:", data);
    setMapValues(data);                 // always remember the latest map payload
    if (!showManualAddress) {
      applyMapToForm(data);             // only apply map data when not in manual mode
    }
  };

  // Manual address toggle handler
  const handleToggleManual = (checked) => {
    console.log("[AddCompanyDrawer][Location] manual toggle:", checked);
    setShowManualAddress(checked);

    if (checked) {
      // Clear map-derived fields when switching to manual
      formik.setValues((v) => ({
        ...v,
        country: "",
        community: "",
        province: "",
        city: "",
        postalCode: "",
        streetAddress: "",
      }));
      // Clear manual address coordinates
      setManualAddressCoords(null);

      // Load countries when manual address is enabled
      if (manualCountries.length === 0) {
        console.log("[AddCompanyDrawer][Location] loading countries for manual mode");
        loadCountries();
      }
    } else {
      // Apply map values when switching back to map mode
      console.log("[AddCompanyDrawer][Location] switching back to map mode. mapValues:", mapValues);
      if (mapValues) applyMapToForm(mapValues);
      // Clear manual address coordinates
      setManualAddressCoords(null);
    }
  };

  // Load countries from API
  const loadCountries = () => {
    try {
      setLoadingCountries(true);

      const countries = Country.getAllCountries();

      const list = countries.map(c => ({
        name: c.name,
        isoCode: c.isoCode,
      }));

      setManualCountries(list);   // [{name, isoCode}]
    } catch (err) {
      toast.error(t("addCompanyAdmin.toast.failedLoadCountries"));
    } finally {
      setLoadingCountries(false);
    }
  };

  // Handle country selection
  const handleCountryChange = (value) => {
    const obj = manualCountries.find(c => c.name === value);

    setSelectedCountry(value);
    setSelectedCountryIso(obj?.isoCode || "");

    setSelectedState("");
    setSelectedStateIso("");
    setSelectedCity("");

    setManualStates([]);
    setManualCities([]);

    formik.setFieldValue("country", value);
    formik.setFieldValue("province", "");
    formik.setFieldValue("city", "");

    if (obj?.isoCode) {
      setLoadingStates(true);
      const states = State.getStatesOfCountry(obj.isoCode).map(s => ({
        name: s.name,
        isoCode: s.isoCode,
      }));
      setManualStates(states);
      setLoadingStates(false);

      geocodeLocation(value, "", "");
    }
  };


  // Handle state selection
  const handleStateChange = (value) => {
    const obj = manualStates.find(s => s.name === value);

    setSelectedState(value);
    setSelectedStateIso(obj?.isoCode || "");

    setSelectedCity("");
    setManualCities([]);

    formik.setFieldValue("province", value);
    formik.setFieldValue("city", "");

    if (selectedCountryIso && obj?.isoCode) {
      setLoadingCities(true);

      const cities = City.getCitiesOfState(selectedCountryIso, obj.isoCode)
        .map(c => c.name)
        .sort();

      setManualCities(cities);
      setLoadingCities(false);

      geocodeLocation(selectedCountry, value, "");
    }
  };


  // Handle city selection
  const handleCityChange = (value) => {
    setSelectedCity(value);
    formik.setFieldValue("city", value);

    if (value && selectedCountry && selectedState) {
      geocodeLocation(selectedCountry, selectedState, value);
    }
  };


  // Geocode location and update map
  const geocodeLocation = async (country, state, city) => {
    try {
      console.log("[AddCompanyDrawer][Location] geocodeLocation request:", { country, state, city });
      const query = [city, state, country].filter(Boolean).join(", ");
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`,
        {
          headers: {
            'User-Agent': 'YourApp/1.0 (contact@example.com)'
          }
        }
      );

      const data = await response.json();

      if (data && data.length > 0) {
        const { lat, lon } = data[0];
        const latitude = parseFloat(lat);
        const longitude = parseFloat(lon);

        // Update formik with coordinates
        formik.setFieldValue("latitude", latitude);
        formik.setFieldValue("longitude", longitude);

        // Update manual address coordinates for map
        setManualAddressCoords({ lat: latitude, lng: longitude });

        console.log("[AddCompanyDrawer][Location] geocodeLocation success:", { latitude, longitude, query });

      } else {
        console.warn("[AddCompanyDrawer][Location] geocodeLocation no results for:", query);

      }
    } catch (error) {
      console.error("[AddCompanyDrawer][Location] geocodeLocation error:", error);
      toast.error(t("addCompanyAdmin.toast.failedGetLocationCoordinates"));
    }
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      middleName: "",
      dob: "",
      adminType: "",
      adminDocumentUrl: "",
      email: "",
      phone: "",
      legalName: "",
      tradeName: "",
      businessEmail: "",
      businessPhone: "",
      businessAddress: "",
      businessSector: "",
      businessActivity: "",
      primaryColor: "#006EC2",
      secondaryColor: "#2C384C",
      companyRegistrationNo: "",
      country: "Spain",
      community: "",
      province: "",
      city: "",
      postalCode: "",
      streetAddress: "",
      // targetRegion: [],
      defaultLanguage: [],
      subscriptionType: [],
      latitude: "",
      longitude: "",
      timezone: "",
      countryCode: "",
      region: "",
      continent: "",
    },
    validate: (values) => {
      const errors = {};

      if (!values.firstName || !values.firstName.trim()) {
        errors.firstName = t("addCompanyAdmin.formValidation.firstNameRequired") || "First name is required";
      }

      if (!values.lastName || !values.lastName.trim()) {
        errors.lastName = t("addCompanyAdmin.formValidation.lastNameRequired") || "Last name is required";
      }

      // if (!values.dob) {
      //   errors.dob = t("addCompanyAdmin.formValidation.dobRequired") || "Date of birth is required";
      // }

      if (!values.email || !values.email.trim()) {
        errors.email = t("addCompanyAdmin.formValidation.emailRequired") || "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
        errors.email = t("addCompanyAdmin.formValidation.emailInvalid") || "Invalid email format";
      }

      if (!values.phone || !values.phone.trim()) {
        errors.phone = t("addCompanyAdmin.formValidation.phoneRequired") || "Phone is required";
      }

      if (!values.adminType) {
        errors.adminType = t("addCompanyAdmin.formValidation.adminTypeRequired") || "Admin type is required";
      }

      // Business fields validation (only if adminType is selected)
      if (values.adminType) {
        // if (!values.legalName || !values.legalName.trim()) {
        //   errors.legalName = t("addCompanyAdmin.formValidation.legalNameRequired") || "Legal name is required";
        // }

        // if (!values.businessEmail || !values.businessEmail.trim()) {
        //   errors.businessEmail = t("addCompanyAdmin.formValidation.businessEmailRequired") || "Business email is required";
        // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.businessEmail)) {
        //   errors.businessEmail = t("addCompanyAdmin.formValidation.emailInvalid") || "Invalid email format";
        // }

        // if (!values.businessPhone || !values.businessPhone.trim()) {
        //   errors.businessPhone = t("addCompanyAdmin.formValidation.businessPhoneRequired") || "Business phone is required";
        // }

        // if (!values.businessSector || !values.businessSector.trim()) {
        //   errors.businessSector = t("addCompanyAdmin.formValidation.businessSectorRequired") || "Business sector is required";
        // }

        // if (!values.targetRegion || values.targetRegion.length === 0) {
        //   errors.targetRegion = t("addCompanyAdmin.formValidation.targetRegionRequired") || "Target region is required";
        // }
      }

      return errors;
    },
    onSubmit: async (values) => {
      setLoading(true); // immediately disable button when clicked
      try {
        // Convert dob to UTC if present
        let submitValues = { ...values };
        if (values.dob) {
          submitValues.dob = convertLocalDateTimeToUTC(values.dob);
        }
        console.log("[AddCompanyDrawer][Submit] Submit clicked. Location snapshot:", {
          locationAllowed,
          showManualAddress,
          latitude: values.latitude,
          longitude: values.longitude,
          country: values.country,
          province: values.province,
          city: values.city,
          mapValues,
          manualAddressCoords,
        });
        // if (!locationAllowed) {
        //   toast.error("You can't use this feature because location access was denied.");

        //   setLoading(false);
        //   return;
        // }

        const hasCoordinates =
          values.latitude !== "" &&
          values.longitude !== "" &&
          values.latitude !== null &&
          values.longitude !== null &&
          !Number.isNaN(Number(values.latitude)) &&
          !Number.isNaN(Number(values.longitude));

        if (!showManualAddress && !locationAllowed && !hasCoordinates) {
          console.warn("[AddCompanyDrawer][Submit] Blocked: no live location permission and no coordinates set.");
          setForceLocationCheck(true);
          setShowPermissionModal(true);  // 👈 open modal only when truly needed
          setLoading(false);
          return;
        }
        const requiredFields = [
          "firstName",
          "lastName",
          "email",
          "phone",
          "adminType",
          // "dob", // Add date of birth as required
        ];

        // Add business fields only if admin type is selected
        if (values.adminType) {
          requiredFields.push(
            // "legalName",
            // "businessEmail",
            // "businessPhone",
            // "businessSector",
            // "targetRegion",
            // "businessAddress" // Add business address for both individual and legal entity
          );
        }
        if (showManualAddress) {
          requiredFields.push("country", "province", "city");
        }
        // Additional validation for legal entity
        // if (values.adminType === 'legal_entity') {
        //   if (!values.companyDocumentUrl) {
        //     toast.error(t("addCompanyAdmin.toast.companyLegalDocumentRequired"));
        //     setLoading(false);
        //     return;
        //   }
        // }


        const emptyFields = requiredFields.filter((key) => {
          const val = values[key];
          return Array.isArray(val) ? val.length === 0 : !val;
        });

        if (emptyFields.length > 0) {
          toast.error(t("addCompanyAdmin.toast.fillRequiredFields"));
          console.log("⚠️ Missing fields:", emptyFields);
          setLoading(false);
          return;
        }

        let companyLogoUrl = "";
        if (logoFile) {
          companyLogoUrl = await uploadImageToServer(logoFile);
        }

        let profileImageUrl = "";
        if (imageFile) {
          profileImageUrl = await uploadImageToServer(imageFile);
        }
        // Prepare formData
        const formData = new FormData();
        // Make latitude and longitude optional - always send empty string if not provided
        formData.append("latitude", submitValues.latitude || "");
        formData.append("longitude", submitValues.longitude || "");
        if (imageFile) {
          formData.append("profile_picture", imageFile);
        }
        if (logoFile) {
          formData.append("company_logo", logoFile);
        }

        if (imageFile) {
          formData.append("profile_picture_url", profileImageUrl);
        }
        if (logoFile) {
          formData.append("company_logo_url", companyLogoUrl);
        }

        const fieldMap = {
          firstName: "first_name",
          lastName: "last_name",
          middleName: "middle_name",
          dob: "dob",
          adminType: "administrator_type",
          adminDocumentUrl: "admin_document_url",
          email: "email",
          phone: "phone_number",
          legalName: "legal_name",
          tradeName: "trade_name",
          businessEmail: "business_email",
          businessPhone: "business_phone_number",
          businessAddress: "business_address",
          businessSector: "business_sector",
          businessActivity: "business_activity",
          primaryColor: "primary_color",
          secondaryColor: "secondary_color",
          companyRegistrationNo: "company_registration_number",
          companyDocumentUrl: "company_document_url",
          country: "country",
          community: "community",
          province: "province",
          city: "city",
          postalCode: "postal_code",
          streetAddress: "street_address",
          // targetRegion: "region_code",
          latitude: "latitude",
          longitude: "longitude",
          timezone: "timezone",
          countryCode: "countryCode",
          region: "region",
          continent: "continent",
        };

        Object.entries(submitValues).forEach(([key, value]) => {
          const backendKey = fieldMap[key] || key;
          if (Array.isArray(value)) {
            value.forEach((v) => formData.append(`${backendKey}[]`, v));
          } else {
            // Make postal code, latitude, and longitude optional - send empty string if not provided
            if (key === "postalCode" || key === "latitude" || key === "longitude") {
              formData.append(backendKey, value || "");
            } else {
              formData.append(backendKey, value);
            }
          }
        });

        // Debug formData
        for (let [key, val] of formData.entries()) {
          console.log(`➡️ ${key}: ${val}`);
        }
        // ✅ CORRECT way to inspect FormData before sending
        const debugPayload = {};
        for (const [key, value] of formData.entries()) {
          // handle files cleanly
          if (value instanceof File) {
            debugPayload[key] = {
              name: value.name,
              type: value.type,
              size: value.size,
            };
          } else {
            debugPayload[key] = value;
          }
        }

        console.log("📦 FORM DATA PAYLOAD:", debugPayload);

        // API Call
        const response = await fetch(`${BASE_URL}/company-admins`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        const result = await response.json();
        console.log("[AddCompanyDrawer][Submit] company-admins API response:", result);
        if (!response.ok) {
          return showToast(toast.error, result, t("addCompanyAdmin.toast.somethingWentWrong"));
        }

        showToast(toast.success, result, t("addCompanyAdmin.toast.companyAdminCreatedInviteSent"));
        setTimeout(() => {
          if (onSuccess) onSuccess();
          onClose();
        }, 1000);
      } catch (error) {
        showToast(toast.error, { message: error.message }, t("addCompanyAdmin.toast.somethingWentWrong"));
        console.error("[AddCompanyDrawer][Submit] API Error:", error);
      } finally {
        setLoading(false); // always re-enable button
      }
    },

  });
  const countryOptions = useMemo(() => {
    return countryList()
      .getData()
      .map((country) => ({
        value: country.label,
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <img
              src={`https://flagcdn.com/w40/${country.value.toLowerCase().slice(0, 2)}.png`}
              alt={country.label}
              style={{ width: 20, height: 15, objectFit: "contain" }}
            />
            {country.label}
          </div>
        ),
        code: country.value,
      }))
  }, [])



  const uploadImageToServer = async (file) => {
    const form = new FormData();
    form.append("image", file);

    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",

      body: form,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");
    // toast.success("Image uploaded successfully!");

    // Use the correct key the API returns (adjust if it's different)
    return data?.data?.url || data?.url || data?.path;
  };

  // Document upload functions
  const uploadAdminDocToServer = async (file) => {
    const form = new FormData();
    form.append("pdf", file);
    const res = await fetch(`${BASE_URL}/upload/pdf`, {
      method: "POST",
      body: form,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");
    return data?.data?.url || data?.url || data?.path || "";
  };
  const uploadPdfToServer = async (file) => {
    const formData = new FormData();
    formData.append("pdf", file);

    const res = await fetch(`${BASE_URL}/upload/pdf`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to upload PDF");
    return data?.data?.url || data?.url || data?.path || "";
  };

  const uploadCompanyDocToServer = async (file) => {
    const form = new FormData();
    form.append("pdf", file);
    const res = await fetch(`${BASE_URL}/upload/pdf`, {
      method: "POST",
      body: form,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");
    return data?.data?.url || data?.url || data?.path || "";
  };


  const handleAdminDocChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isPdf = file.type === "application/pdf";
    const isImage = file.type.startsWith("image/");

    if (!isPdf && !isImage) {
      toast.error(t("addCompanyAdmin.validation"));
      if (docInputRef.current) docInputRef.current.value = "";
      return;
    }

    try {
      setUploadingAdminDoc(true);
      setAdminDocFileName(file.name);

      let url;
      if (isPdf) {
        url = await uploadAdminDocToServer(file);
      } else if (isImage) {
        url = await uploadImageToServer(file);
      }

      formik.setFieldValue("adminDocumentUrl", url);
      toast.success(t("upload.documentUploaded"));
    } catch (err) {
      toast.error(t("addCompanyAdmin.toast.failedUploadDocument"));
      formik.setFieldValue("adminDocumentUrl", "");
      setAdminDocFileName("");
    } finally {
      setUploadingAdminDoc(false);
      if (docInputRef.current) docInputRef.current.value = "";
    }
  };
  const handleCompanyDocChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isPdf = file.type === "application/pdf";
    const isImage = file.type.startsWith("image/");

    if (!isPdf && !isImage) {
      toast.error(t("addCompanyAdmin.validation"));
      if (companyDocInputRef.current) companyDocInputRef.current.value = "";
      return;
    }

    try {
      setUploadingCompanyDoc(true);
      setCompanyDocFileName(file.name);

      let url;
      if (isPdf) {
        url = await uploadPdfToServer(file); // <-- your PDF API endpoint
      } else if (isImage) {
        url = await uploadImageToServer(file); // <-- your Image API endpoint
      }

      formik.setFieldValue("companyDocumentUrl", url);
      toast.success(t("upload.documentUploaded"));
    } catch (err) {
      toast.error(t("addCompanyAdmin.toast.failedUploadDocument"));
      formik.setFieldValue("companyDocumentUrl", "");
      setCompanyDocFileName("");
    } finally {
      setUploadingCompanyDoc(false);
      if (companyDocInputRef.current) companyDocInputRef.current.value = "";
    }
  };


  const execIdFromRedux = useSelector((s) => s.auth?.user?.id); // <-- replace with your real path
  const executiveId = execIdFromRedux // fallback for testing
  console.log(executiveId)
  const [zones, setZones] = useState([]);          // <-- new
  const [zonesLoading, setZonesLoading] = useState(false);

  // Load countries on component mount and when modal opens
  useEffect(() => {
    if (open) {
      loadCountries();
    }
  }, [open]);
  useEffect(() => {
    if (!open || !executiveId || !token) return;
    const fetchZones = async () => {
      try {
        setZonesLoading(true);
        const res = await fetch(`${BASE_URL}/account-executive/${executiveId}/assigned-zone`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        console.log(json)
        if (!res.ok || json?.error) throw new Error(json?.message || "Failed to load zones");

        const apiZones = Array.isArray(json?.data?.territory_zone) ? json.data.territory_zone : [];
        setZones(apiZones);


        // if (apiZones.length && (!formik.values.targetRegion || formik.values.targetRegion.length === 0)) {
        //   formik.setFieldValue("targetRegion", apiZones);
        // }
      } catch (err) {
        // toast.error(err.message);
        setZones([]); // safe fallback
      } finally {
        setZonesLoading(false);
      }
    };
    fetchZones();
  }, [open, executiveId, token]);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 530,
          maxWidth: "100%",
          overflow: "visible",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Toaster />
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross || "/placeholder.svg"} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: "#2C384C" }}>
            {t("addCompanyAdmin.title")}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        <CustomText
          sx={{
            ...textStyles.h1,
            fontSize: 18,
            mb: 3,
            mt: 1,
            fontWeight: 600,
            color: "#000000",
            textAlign: "left",
          }}
        >
          {t("addCompanyAdmin.adminDetails")}
        </CustomText>

        <Box display="flex" flexWrap="wrap" gap={1.5} mb={2}>
          <Box sx={{ flex: 1, minWidth: "250px" }}>
            <label className="field_label">
              {t("addCompanyAdmin.firstName")} <span className="red_asterisk">*</span>
            </label>
            <input
              className="project_input"
              style={{
                height: "40px",
                width: "100%",
                borderColor: formik.touched.firstName && formik.errors.firstName ? "#d32f2f" : undefined
              }}
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.firstName && formik.errors.firstName && (
              <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                {formik.errors.firstName}
              </span>
            )}
          </Box>
          <Box sx={{ flex: 1, minWidth: "250px" }}>
            <label className="field_label">{t("middleName")}</label>
            <input
              className="project_input"
              style={{ height: "40px", width: "100%" }}
              name="middleName"
              value={formik.values.middleName}
              onChange={formik.handleChange}
            />
          </Box>
          <Box sx={{ flex: 1, minWidth: "250px" }}>
            <label className="field_label">
              {t("addCompanyAdmin.lastName")} <span className="red_asterisk">*</span>
            </label>
            <input
              className="project_input"
              style={{
                height: "40px",
                width: "100%",
                borderColor: formik.touched.lastName && formik.errors.lastName ? "#d32f2f" : undefined
              }}
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.lastName && formik.errors.lastName && (
              <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                {formik.errors.lastName}
              </span>
            )}
          </Box>
        </Box>

        <Box display="flex" gap={1.5} mb={2}>
          <Box sx={{ flex: 1 }}>
            <label className="field_label">{t("dateOfBirth")}
              {/* <span className="red_asterisk">*</span> */}
            </label>

            <input
              type="date"
              name="dob"
              value={formik.values.dob}
              // onChange={formik.handleChange}
              onChange={(e) => {
                const val = e.target.value; // format: yyyy-mm-dd
                const parts = val.split("-");
                if (parts[0] && parts[0].length > 4) {
                  parts[0] = parts[0].slice(0, 4); // trim extra digits
                }
                const cleanVal = parts.join("-");
                formik.setFieldValue("dob", cleanVal); // manually set sanitized value
              }}
              onBlur={formik.handleBlur}
              style={{
                height: "40px",
                width: "100%",
                borderColor: formik.touched.dob && formik.errors.dob ? "#d32f2f" : undefined
              }}
              className="project_input"

            />
            {formik.touched.dob && formik.errors.dob && (
              <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                {formik.errors.dob}
              </span>
            )}
          </Box>
          <Box sx={{ flex: 1 }}>
            <label className="field_label">
              {t("settings.adminType")} <span className="red_asterisk">*</span>
            </label>
            <select
              className="project_input"
              style={{
                height: "40px",
                width: "100%",
                borderColor: formik.touched.adminType && formik.errors.adminType ? "#d32f2f" : undefined
              }}
              name="adminType"
              value={formik.values.adminType}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="">{t("settings.selectType")}</option>
              <option value="individual">{t("entityTypes.individual")}</option>
              <option value="legal_entity">{t("entityTypes.legal_entity")}</option>
            </select>
            {formik.touched.adminType && formik.errors.adminType && (
              <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                {formik.errors.adminType}
              </span>
            )}
          </Box>
        </Box>

        {/* Administrator Document - Show for both Individual and Legal Entity */}


        <Box display="flex" gap={1.5} mb={2}>
          <Box sx={{ flex: 1 }}>
            <label className="field_label">
              {t("addCompanyAdmin.email")} <span className="red_asterisk">*</span>
            </label>
            <input
              className="project_input"
              style={{
                height: "40px",
                width: "100%",
                borderColor: formik.touched.email && formik.errors.email ? "#d32f2f" : undefined
              }}
              name="email"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.email && formik.errors.email && (
              <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                {formik.errors.email}
              </span>
            )}
          </Box>

          <Box sx={{ flex: 1 }}>
            <label className="field_label">
              {t("addCompanyAdmin.phoneNo")}<span className="red_asterisk">*</span>
            </label>

            <Box
              sx={{
                border: formik.touched.phone && formik.errors.phone ? "2px solid #d32f2f" : "2px solid rgba(9,30,66,0.14)",
                borderRadius: "6px",
                backgroundColor: "white",
                mt: "0px",
                "& .form-control": {
                  border: "none !important",
                  outline: "none !important",
                  boxShadow: "none !important",
                  width: "100%",
                  height: "36px",
                  fontSize: "14px",
                  paddingLeft: "48px",
                  borderRadius: "6px",
                  fontFamily: "Poppins, sans-serif !important",
                  backgroundColor: "transparent",
                },
                "& .flag-dropdown": {
                  border: "none !important",
                  borderRight: "1px solid #ccc !important",
                  backgroundColor: "#f9f9f9",
                  borderTopLeftRadius: "6px",
                  borderBottomLeftRadius: "6px",
                },
              }}
            >
              <PhoneInput
                countryCodeEditable={false}
                country={"us"}
                value={formik.values.phone}
                onChange={(value) => {
                  formik.setFieldValue("phone", value);
                  formik.setFieldTouched("phone", true);
                }}
                onBlur={() => formik.setFieldTouched("phone", true)}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                containerClass="react-tel-input"
                inputClass="form-control"
                buttonClass="flag-dropdown"


              // enableSearch={true}  
              />
            </Box>
            {formik.touched.phone && formik.errors.phone && (
              <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                {formik.errors.phone}
              </span>
            )}
          </Box>
        </Box>


        <Box mb={2}>
          <label className="field_label">
            {t("profilePicture")}
          </label>

          <Box
            sx={{
              position: "relative",  // <-- to position the cross icon
              border: "2px dashed #091E4224",
              backgroundColor: "#F6F8FB",
              height: 130,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            // onClick={() => !uploadedImage && imageInputRef.current.click()}
            onClick={(e) => {
              e.stopPropagation();
              setProfileMenuEl(e.currentTarget);
            }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const file = e.dataTransfer.files[0];
              if (file) handleFileChange({ target: { files: [file] } }, "image");
            }}
          >

            {/* Cross icon when image uploaded */}
            {uploadedImage && (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation(); // prevent re-opening file picker
                  setUploadedImage(null);
                  setImageFile(null);
                  if (imageInputRef.current) imageInputRef.current.value = "";
                }}
                sx={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  bgcolor: "#fff",
                  border: "1px solid #ccc",
                  width: 22,
                  height: 22,
                  "&:hover": { bgcolor: "#f5f5f5" },
                }}
              >
                <CloseRoundedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            )}

            {uploadedImage ? (
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <span style={{ fontSize: "15px", fontWeight: 500, color: "#2C384C" }}>
                  {t("upload.imageUploaded")}
                </span>
              </Box>
            ) : (
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setProfileMenuEl(e.currentTarget);
                  }}
                  sx={{
                    // position: "absolute",
                    // bottom: 6,
                    // right: 6,
                    bgcolor: "#fff",
                    border: "1px solid #ccc",
                    width: 26,
                    height: 26,
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  <AddIcon sx={{ fontSize: 18 }} />
                </IconButton>
                <img src={drag || "/placeholder.svg"} alt="drag" />
                <span style={{ fontSize: "15px", fontWeight: 500 }}>
                  {t("addCompanyAdmin.dragFiles")}{" "}
                  <span style={{ color: "#0052CC" }}>{t("addCompanyAdmin.browse")}</span>
                </span>
              </Box>
            )}

            <input
              type="file"
              ref={imageInputRef}
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, "image")}
              accept="image/*"
            />
          </Box>
        </Box>


        <Box mb={2}>
          <label className="field_label">
            {t("settings.adminDocument")}
          </label>

          <Box
            sx={{
              position: "relative", // for cross icon
              border: "2px dashed #091E4224",
              backgroundColor: "#F6F8FB",
              height: 100,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "6px",
              cursor: uploadingAdminDoc ? "not-allowed" : "pointer",
              mt: 1,
              transition: "0.2s",
              "&:hover": { backgroundColor: "#F0F0F0" },
            }}
            // onClick={() => !uploadingAdminDoc && docInputRef.current?.click()}
            onClick={(e) => {
              e.stopPropagation();
              setAdminMenuEl(e.currentTarget);
            }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const file = e.dataTransfer.files[0];
              if (file) handleAdminDocChange({ target: { files: [file] } });
            }}
          >
            {/* cross icon when uploaded */}
            {adminDocFileName && (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setAdminDocFileName("");
                  formik.setFieldValue("adminDocumentUrl", "");
                  if (docInputRef.current) docInputRef.current.value = "";
                }}
                sx={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  bgcolor: "#fff",
                  border: "1px solid #ccc",
                  "&:hover": { bgcolor: "#f5f5f5" },
                  width: 22,
                  height: 22,
                }}
              >
                <CloseRoundedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            )}

            {uploadingAdminDoc ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={20} />
                <span style={{ fontSize: "15px", color: "#0052CC" }}>
                  {t("upload.uploading")}
                </span>
              </Box>
            ) : adminDocFileName ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <span style={{ fontSize: "15px", fontWeight: 500, color: "#2C384C" }}>
                  {adminDocFileName}
                </span>
                {formik.values.adminDocumentUrl && (
                  <span style={{ fontSize: "13px", color: "green" }}>{t("upload.uploaded")}</span>
                )}
              </Box>
            ) : (
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setAdminMenuEl(e.currentTarget);
                  }}
                  sx={{
                    // position: "absolute",
                    // bottom: 6,
                    // right: 6,
                    bgcolor: "#fff",
                    border: "1px solid #ccc",
                    width: 26,
                    height: 26,
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  <AddIcon sx={{ fontSize: 18 }} />
                </IconButton>
                <span style={{ fontSize: "15px", fontWeight: 500, color: "#6B778C" }}>
                  {t("settings.dragFileHere")}
                </span>
              </Box>
            )}

            <input
              ref={docInputRef}
              type="file"
              accept="image/*,.pdf"
              style={{ display: "none" }}
              onChange={handleAdminDocChange}
            />
          </Box>

          {/* hint below the box */}
          <Typography
            sx={{ fontSize: 13, color: "#888", mt: 0.5, fontFamily: 'Poppins, sans-serif', }}
          >
            {t("addCompanyAdmin.validation")}
          </Typography>
        </Box>

        <Menu
          anchorEl={adminMenuEl}
          open={openAdminMenu}
          onClose={() => setAdminMenuEl(null)}
        >
          <MenuItem
            onClick={() => {
              setAdminMenuEl(null);
              openCameraFor("admin");
            }}
            sx={{ fontSize: "13px", fontFamily: "Poppins" }}
          >
            {t("takePhoto")}
          </MenuItem>

          <MenuItem
            onClick={() => {
              setAdminMenuEl(null);
              docInputRef.current?.click(); // existing image/pdf upload
            }}
            sx={{ fontSize: "13px", fontFamily: "Poppins" }}
          >
            {t("chooseFromGallery")}
          </MenuItem>
        </Menu>
        {/* Business Details - Only show when Administrator Type is selected */}
        {formik.values.adminType && (
          <Box mt={2.5}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000000", textAlign: "left" }}>
                {t("addCompanyAdmin.businessDetails")}
              </CustomText>
              {/* <img src={down || "/placeholder.svg"} width={40} height={30} /> */}
            </Box>
            <Box display="flex" gap={1.5} mb={2}>
              <Box sx={{ flex: 1 }}>
                <label className="field_label">
                  {formik.values.adminType === "individual"
                    ? t("addCompanyAdmin.businessName")
                    : t("addCompanyAdmin.companyLegalName")}
                  {/* <span className="red_asterisk">*</span> */}
                </label>
                <input
                  className="project_input"
                  style={{
                    height: "40px",
                    width: "100%",
                    borderColor: formik.touched.legalName && formik.errors.legalName ? "#d32f2f" : undefined
                  }}
                  name="legalName"
                  value={formik.values.legalName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {/* {formik.touched.legalName && formik.errors.legalName && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                    {formik.errors.legalName}
                  </span>
                )} */}
              </Box>
              {/* Company Business Name - Only show for Legal Entity */}
              {formik.values.adminType === 'legal_entity' && (
                <Box sx={{ flex: 1 }}>
                  <label className="field_label">{t("settings.companyBusinessName")}</label>
                  <input
                    className="project_input"
                    style={{ height: "40px", width: "100%" }}
                    name="tradeName"
                    value={formik.values.tradeName}
                    onChange={formik.handleChange}
                  />
                </Box>
              )}
            </Box>

            <Box mb={2}>
              <Box ref={dropdownRef}>
                <label className="field_label">
                  {t("addCompanyAdmin.businessSector")}
                  {/* <span className="red_asterisk">*</span> */}
                </label>
                <div className="dropdown-wrapper" >
                  <div
                    className={`dropdown-header ${dropdownOpen ? "open" : ""}`}
                    onClick={() => setDropdownOpen(!dropdownOpen)}

                  >
                    {formik.values.businessSector || t("addCompanyAdmin.select")}
                    <span style={{ transform: dropdownOpen ? "rotate(180deg)" : "rotate(0)", transition: "0.3s" }}>
                      <img src={arrow || "/placeholder.svg"} alt="arrow" />
                    </span>
                  </div>

                  {dropdownOpen && (
                    <div className="dropdown-list" style={{ height: "200px", overflowY: "auto" }}>
                      {sectors.map((sector) => (
                        <div
                          key={sector}
                          className={`dropdown-item ${formik.values.businessSector === sector ? "selected" : ""}`}
                          onClick={() => {
                            formik.setFieldValue("businessSector", sector)
                            formik.setFieldTouched("businessSector", true)
                            setDropdownOpen(false)
                          }}
                        >
                          {sector}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {/* {formik.touched.businessSector && formik.errors.businessSector && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                    {formik.errors.businessSector}
                  </span>
                )} */}
              </Box>
            </Box>

            {/* Company Registration Number - Only show for Legal Entity */}
            {formik.values.adminType === 'legal_entity' && (
              <Box mb={2}>
                <label className="field_label">{t("addCompanyAdmin.companyRegistrationNo")}</label>
                <input
                  className="project_input"
                  style={{ height: "40px", width: "100%" }}
                  name="companyRegistrationNo"
                  value={formik.values.companyRegistrationNo}
                  onChange={formik.handleChange}
                />
              </Box>
            )}

            {/* Business Activity */}
            <Box mb={2}>
              <label className="field_label">{t("settings.businessActivity")}</label>
              <textarea
                className="project_input"
                style={{ height: "80px", width: "100%", resize: "vertical" }}
                name="businessActivity"
                value={formik.values.businessActivity}
                onChange={formik.handleChange}
                placeholder={t("settings.businessActivityPlaceholder")}
              />
            </Box>

            {/* Company Legal Document - Only show for Legal Entity */}
            {formik.values.adminType === 'legal_entity' && (

              <Box mb={2}>
                <label className="field_label">
                  {t("settings.companyLegalDocument")}
                  {/* <span className="red_asterisk">*</span> */}
                </label>

                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    setCompanyMenuEl(e.currentTarget);
                  }}
                  // onClick={() => !uploadingCompanyDoc && !companyDocFileName && companyDocInputRef.current?.click()}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    e.preventDefault();
                    const file = e.dataTransfer.files[0];
                    if (file) handleCompanyDocChange({ target: { files: [file] } });
                  }}
                  sx={{
                    border: "2px dashed #091E4224",
                    backgroundColor: "#F6F8FB",
                    height: 130,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "6px",
                    cursor: uploadingCompanyDoc ? "not-allowed" : "pointer",
                    mt: 1,
                    position: "relative",
                  }}
                >
                  {companyDocFileName ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, position: "relative" }}>
                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#2C384C" }}>
                        {companyDocFileName}
                      </span>
                      {formik.values.companyDocumentUrl && (
                        <span style={{ fontSize: "13px", color: "green" }}>✓ {t("upload.uploaded")}</span>
                      )}

                      {/* Cross icon to remove */}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setCompanyDocFileName("");
                          formik.setFieldValue("companyDocumentUrl", "");
                        }}
                        style={{
                          position: "absolute",
                          top: -45,
                          right: -50,
                          fontSize: "18px",
                          color: "#D32F2F",
                          cursor: "pointer",
                        }}
                      >
                        <CloseRoundedIcon sx={{ fontSize: 16 }} />
                      </span>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCompanyMenuEl(e.currentTarget);
                        }}
                        sx={{
                          // position: "absolute",
                          // bottom: 6,
                          // right: 6,
                          bgcolor: "#fff",
                          border: "1px solid #ccc",
                          width: 26,
                          height: 26,
                          "&:hover": { bgcolor: "#f5f5f5" },
                        }}
                      >
                        <AddIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                      <span style={{ fontSize: "15px", fontWeight: 500, color: "#6B778C" }}>
                        {t("addCompanyAdmin.dragFileHere")}
                      </span>
                    </Box>
                  )}

                  <input
                    ref={companyDocInputRef}
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg"
                    style={{ display: "none" }}
                    onChange={handleCompanyDocChange}
                  />
                </Box>
                <Typography
                  sx={{ fontSize: 13, color: "#888", mt: 0.5, fontFamily: 'Poppins, sans-serif', }}
                >
                  {t("addCompanyAdmin.validation")}            </Typography>
              </Box>

            )}
            <Menu
              anchorEl={companyMenuEl}
              open={openCompanyMenu}
              onClose={() => setCompanyMenuEl(null)}
            >
              <MenuItem
                onClick={() => {
                  setCompanyMenuEl(null);
                  openCameraFor("company");
                }}
                sx={{ fontSize: "13px", fontFamily: "Poppins" }}
              >
                {t("takePhoto")}
              </MenuItem>

              <MenuItem
                onClick={() => {
                  setCompanyMenuEl(null);
                  companyDocInputRef.current?.click(); // existing image/pdf upload
                }}
                sx={{ fontSize: "13px", fontFamily: "Poppins" }}
              >
                {t("chooseFromGallery")}
              </MenuItem>
            </Menu>
            {/* Primary and Secondary Color Fields */}
            <Box display="flex" gap={1.5} mb={2}>
              <Box sx={{ flex: 1 }}>
                <label className="field_label">{t("settings.primaryColor")}</label>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <input
                    type="color"
                    name="primaryColor"
                    value={formik.values.primaryColor}
                    onChange={formik.handleChange}
                    style={{ width: "60px", height: "40px", border: "none", borderRadius: "4px", cursor: "pointer" }}
                  />
                  <input
                    className="project_input"
                    name="primaryColor"
                    value={formik.values.primaryColor}
                    onChange={formik.handleChange}
                    style={{ height: "40px", width: "calc(100% - 70px)" }}
                  />
                </Box>
              </Box>
              <Box sx={{ flex: 1 }}>
                <label className="field_label">{t("settings.secondaryColor")}</label>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <input
                    type="color"
                    name="secondaryColor"
                    value={formik.values.secondaryColor}
                    onChange={formik.handleChange}
                    style={{ width: "60px", height: "40px", border: "none", borderRadius: "4px", cursor: "pointer" }}
                  />
                  <input
                    className="project_input"
                    name="secondaryColor"
                    value={formik.values.secondaryColor}
                    onChange={formik.handleChange}
                    style={{ height: "40px", width: "calc(100% - 70px)" }}
                  />
                </Box>
              </Box>
            </Box>

            <Box display="flex" gap={1.5} mb={2}>
              <Box sx={{ flex: 1 }}>
                <label className="field_label">
                  {t("addCompanyAdmin.businessEmail")}
                </label>
                <input
                  className="project_input"
                  style={{
                    height: "40px",
                    width: "100%",
                    borderColor: formik.touched.businessEmail && formik.errors.businessEmail ? "#d32f2f" : undefined
                  }}
                  name="businessEmail"
                  type="email"
                  value={formik.values.businessEmail}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.businessEmail && formik.errors.businessEmail && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                    {formik.errors.businessEmail}
                  </span>
                )}
              </Box>

              <Box sx={{ flex: 1 }}>
                <label className="field_label">
                  {t("addCompanyAdmin.businessPhoneNo")}
                </label>

                <Box
                  sx={{
                    border: formik.touched.businessPhone && formik.errors.businessPhone ? "2px solid #d32f2f" : "2px solid rgba(9,30,66,0.14)",
                    borderRadius: "6px",
                    backgroundColor: "white",
                    mt: "0px",
                    "& .form-control": {
                      border: "none !important",
                      outline: "none !important",
                      boxShadow: "none !important",
                      width: "100%",
                      height: "36px",
                      fontSize: "14px",
                      paddingLeft: "48px",
                      borderRadius: "6px",
                      fontFamily: "Poppins, sans-serif !important",
                      backgroundColor: "transparent",
                    },
                    "& .flag-dropdown": {
                      border: "none !important",
                      borderRight: "1px solid #ccc !important",
                      backgroundColor: "#f9f9f9",
                      borderTopLeftRadius: "6px",
                      borderBottomLeftRadius: "6px",
                    },
                  }}
                >
                  <PhoneInput
                    countryCodeEditable={false}
                    country={"us"}
                    value={formik.values.businessPhone}
                    onChange={(value) => {
                      formik.setFieldValue("businessPhone", value);
                      formik.setFieldTouched("businessPhone", true);
                    }}
                    onBlur={() => formik.setFieldTouched("businessPhone", true)}
                    inputProps={{
                      name: "businessPhone",
                      required: true,
                    }}
                    containerClass="react-tel-input"
                    inputClass="form-control"
                    buttonClass="flag-dropdown"
                  />
                </Box>
                {formik.touched.businessPhone && formik.errors.businessPhone && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
                    {formik.errors.businessPhone}
                  </span>
                )}
              </Box>
            </Box>





            <Box mb={2}>
              <label className="field_label">
                {t("addCompanyAdmin.logo")}
              </label>

              <Box
                sx={{
                  position: "relative", // enable cross icon positioning
                  border: "2px dashed #091E4224",
                  backgroundColor: "#F6F8FB",
                  height: 130,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                onClick={() => !uploadedLogo && logoInputRef.current.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  const file = e.dataTransfer.files[0];
                  if (file) {
                    handleFileChange({ target: { files: [file] } }, "logo");
                  }
                }}
              >
                {/* Cross icon — shown only when logo uploaded */}
                {uploadedLogo && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setUploadedLogo(null);
                      setLogoFile(null);
                      if (logoInputRef.current) logoInputRef.current.value = "";
                    }}
                    sx={{
                      position: "absolute",
                      top: 6,
                      right: 6,
                      bgcolor: "#fff",
                      border: "1px solid #ccc",
                      width: 22,
                      height: 22,
                      "&:hover": { bgcolor: "#f5f5f5" },
                    }}
                  >
                    <CloseRoundedIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                )}

                {uploadedLogo ? (
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <span style={{ fontSize: "15px", fontWeight: 500, color: "#2C384C" }}>
                      {t("upload.logoUpload")}
                    </span>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <img src={drag || "/placeholder.svg"} alt="drag" />
                    <span style={{ fontSize: "15px", fontWeight: 500 }}>
                      {t("addCompanyAdmin.dragFiles")}{" "}
                      <span style={{ color: "#0052CC" }}>{t("addCompanyAdmin.browse")}</span>
                    </span>
                  </Box>
                )}

                <input
                  type="file"
                  ref={logoInputRef}
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "logo")}
                  accept="image/*"
                />
              </Box>
            </Box>


          </Box>
        )}

        <Box mt={2.5}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000000", textAlign: "left" }}>
              {t("addCompanyAdmin.addressDetails")}
            </CustomText>
            {/* <img src={down || "/placeholder.svg"} width={40} height={30} /> */}
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mt: 1,
            }}
          >
            <Checkbox
              checked={showManualAddress}
              onChange={(e) => handleToggleManual(e.target.checked)}
            />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 500,
                color: "#000000",
                textAlign: "left",
              }}
            >
              {t("settings.manualAddress")}
            </CustomText>
          </Box>
          {/* Map - only show when manual address is not checked */}
          {!showManualAddress && (
            <Box mb={2}>
              <Location
                onChange={handleMapAddress}
                onPermission={(allowed) => {
                  console.log("[AddCompanyDrawer][Location] onPermission callback:", allowed);
                  setLocationAllowed(allowed);
                  setForceLocationCheck(false);
                  if (allowed) setShowPermissionModal(false);
                }}
                forceOpen={forceLocationCheck && !locationAllowed && open}
                manualCoords={manualAddressCoords} // 👈 pass manual address coordinates
              />
            </Box>
          )}

          {/* Manual Address Toggle */}


          {/* Manual Address Selection - Show when checkbox is checked */}
          {showManualAddress && (
            <Box sx={{ mt: 2, mb: 2 }}>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#000000",
                  textAlign: "left",
                  mb: 2,
                }}
              >
                {t("settings.manualAddressSelection")}
              </CustomText>

              {/* Country Dropdown */}
              <Box sx={{ mb: 2 }}>
                <label className="field_label">
                  {t("settings.country")}<span className="red_asterisk">*</span>
                </label>
                {/* <select
                  className="project_input"
                  style={{ height: "40px", width: "100%" }}
                  value={selectedCountry}
                  onChange={(e) => handleCountryChange(e.target.value)}
                  disabled={loadingCountries}
                >
                  <option value="">
{loadingCountries
  ? t("settings.loadingCountries")
  : t("settings.selectCountry")}
                  </option>
              {manualCountries.map((c) => (
  <option key={c.isoCode} value={c.name}>
    {c.name}
  </option>
))}
                </select> */}
                <FormControl
                  fullWidth
                  size="small"

                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 38,
                      borderRadius: "6px",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                      "& fieldset": {
                        borderColor: "#091E4224",
                        borderWidth: "2px",
                      },
                      "&:hover fieldset": {
                        borderColor: selectedState ? "#1976d2" : "#ccc",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: selectedState ? "#1976d2" : "#ccc",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#f5f5f5",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                      color: "#6B778C",
                      "&.Mui-focused": {
                        color: selectedState ? "#1976d2" : "#ccc",
                      },
                    },
                  }}
                >
                  <SearchableDropdown
                    value={selectedCountry}
                    onChange={(value) => handleCountryChange(value)}
                    options={manualCountries.map((c) => c.name)}
                    placeholder={t("settings.selectCountry")}
                    disabled={loadingCountries}
                  />
                </FormControl>
              </Box>




              {/* Province/State Dropdown */}
              <Box sx={{ mb: 2 }}>
                <label className="field_label">
                  {t("settings.provinceState")}<span className="red_asterisk">*</span>
                </label>
                <FormControl
                  fullWidth
                  size="small"

                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 38,
                      borderRadius: "6px",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                      "& fieldset": {
                        borderColor: "#091E4224",
                        borderWidth: "2px",
                      },
                      "&:hover fieldset": {
                        borderColor: selectedState ? "#1976d2" : "#ccc",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: selectedState ? "#1976d2" : "#ccc",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#f5f5f5",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                      color: "#6B778C",
                      "&.Mui-focused": {
                        color: selectedState ? "#1976d2" : "#ccc",
                      },
                    },
                  }}
                >
                  <SearchableDropdown
                    value={selectedState}
                    onChange={(value) => handleStateChange(value)}
                    options={manualStates.map((s) => s.name)}
                    placeholder={
                      !selectedCountry
                        ? t("settings.selectCountryFirst")
                        : t("settings.selectProvinceState")
                    }
                    disabled={!selectedCountry || loadingStates}
                  />
                </FormControl>
              </Box>

              {/* City Dropdown */}
              <Box sx={{ mb: 2 }}>
                <label className="field_label">
                  {t("settings.city")}<span className="red_asterisk">*</span>
                </label>
                <FormControl
                  fullWidth
                  size="small"
                  disabled={!selectedState}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 38,
                      borderRadius: "6px",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                      "& fieldset": {
                        borderColor: "#091E4224",
                        borderWidth: "2px",
                      },
                      "&:hover fieldset": {
                        borderColor: selectedState ? "#1976d2" : "#ccc",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: selectedState ? "#1976d2" : "#ccc",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#f5f5f5",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                      color: "#6B778C",
                      "&.Mui-focused": {
                        color: selectedState ? "#1976d2" : "#ccc",
                      },
                    },
                  }}
                >
                  <SearchableDropdown
                    value={selectedCity}
                    onChange={(value) => handleCityChange(value)}
                    options={manualCities}
                    placeholder={
                      !selectedState
                        ? t("settings.selectProvinceStateFirst")
                        : t("settings.selectCity")
                    }
                    disabled={!selectedState || loadingCities}
                  />
                </FormControl>

              </Box>

              {/* Business Address Field - Show below city */}
              <Box sx={{ mb: 2 }}>
                <label className="field_label">
                  {t("settings.businessAddress")}
                </label>
                <textarea
                  className="project_input"
                  style={{ height: "80px", width: "100%", resize: "vertical" }}
                  name="businessAddress"
                  value={formik.values.businessAddress}
                  onChange={formik.handleChange}
                  placeholder={t("settings.enterBusinessAddress")} />
              </Box>
            </Box>
          )}


        </Box>

        <Box sx={{ mt: 3 }}>

          <CustomButton
            onClick={formik.handleSubmit}
            disabled={loading}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {loading && (
                  <CircularProgress size={18} thickness={4} sx={{ color: "#ffffff" }} />
                )}
                <img src={save || "/placeholder.svg"} alt="save" style={{ width: 16, height: 16 }} />
                {t("addCompanyAdmin.saveInvite")}
              </Box>
            }
            size="medium"
          />
        </Box>
      </Box>
      <LocationPermissionModal
        open={showPermissionModal}
        onRefresh={() => {
          setShowPermissionModal(false);
          setForceLocationCheck(true);
        }}
        onCancel={() => {
          setShowPermissionModal(false);
          setForceLocationCheck(false);
        }}
      />

      {/* Image Cropper Modal */}
      {cropModalOpen && (
        <ImageCropper
          onCropComplete={handleCropComplete}
          selectedImage={selectedImage}
          onClose={() => {
            setCropModalOpen(false);
            setSelectedImage(null);
            setCroppingType(null);
          }}
        />
      )}
      <Menu
        anchorEl={profileMenuEl}
        open={openProfileMenu}
        onClose={() => setProfileMenuEl(null)}
      >
        <MenuItem
          onClick={() => {
            setProfileMenuEl(null);
            openCameraFor("profile");
          }}
          sx={{ fontSize: "13px", fontFamily: "Poppins" }}
        >
          {t("takePhoto")}
        </MenuItem>

        <MenuItem
          onClick={() => {
            setProfileMenuEl(null);
            imageInputRef.current?.click(); // existing gallery flow
          }}
          sx={{ fontSize: "13px", fontFamily: "Poppins" }}
        >
          {t("chooseFromGallery")}
        </MenuItem>
      </Menu>
      {showCamera && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            p: 2,
          }}
        >
          <Box
            sx={{
              width: "90%",
              maxWidth: 440,
              bgcolor: "#fff",
              borderRadius: "12px",
              p: 2,
            }}
          >
            {!capturedImage ? (
              <Webcam
                ref={webcamRef}
                audio={false}
                screenshotFormat="image/jpeg"
                style={{ width: "100%", borderRadius: 10 }}
                videoConstraints={{ facingMode: "user" }}
              />
            ) : (
              <img
                src={capturedImage}
                alt="Captured"
                style={{ width: "100%", borderRadius: 10 }}
              />
            )}

            <Box sx={{ display: "flex", gap: 1.5, mt: 2, justifyContent: "center" }}>
              {!capturedImage ? (
                <CustomButton
                  label={takingPhoto ? t("upload.uploading") : t("capture")}
                  onClick={capturePhoto}
                  disabled={takingPhoto}
                />
              ) : (
                <CustomButton
                  label={t("retake")}
                  onClick={() => setCapturedImage(null)}
                />
              )}

              <CustomButton
                label={t("close")}
                onClick={() => {
                  setShowCamera(false);
                  setCameraTarget(null);
                  setCapturedImage(null);
                }}
                sx={{ backgroundColor: "#E0E0E0", color: "#333" }}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Drawer>
  )
}

export default AddCompanyDrawer



















